<template>
<div class="user-panel">
  <div class="icons">
    <img @click="$router.push('/')" class="home" src="../../../assets/navbar/Home.png"  alt="">
    <img src="../../../assets/icon/chat.svg"  alt="">
    <img src="../../../assets/icon/notif.svg" @click="$router.push('/panel/notification')" alt="">
    <img src="../../../assets/icon/wallet.svg" @click="$router.push('/panel/wallet')"  alt="">
  </div>

  <div @click="showPanel = !showPanel" class="name">
    <img  src="../../../assets/icon/bottom-arrow.png" alt="">
    <span class="txt-name">{{state.userInfo.firstName}} {{state.userInfo.lastName}}</span>
    <ul class="list" v-if="showPanel === true">
      <li @click="$router.push({name:item.name})" v-for="(item , index) in data" :key="index">
        <div class="item">
          <img :src="require('../../../assets/icon/panelTrade/' + item.logo)" alt="">
          <span>{{item.title}}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: "user-panel",

  data(){
    return{
      showPanel:false,
      data:[
        {name:'Dashboard' , logo:'dashboard.png' , title:'داشبورد'},
        {name:'Portfolio' , logo:'portfilo.png' , title:'پورتفولیو'},
        {name:'History' , logo:'history.png' , title:'تاریخچه'},
        {name:'OTC' , logo:'panel.png' , title:'پنل OTC'},
        {name:'GoldTrade' , logo:'gold.png' , title:'بازار طلا'},
      ]
    }
  },

  created() {
    //close header div function
    window.addEventListener("click", (event) => {
      if (!event.target.closest('.name')) {
        this.showPanel = false
      }
    })
  },

}
</script>

<style lang="scss" scoped>
.txt-name{
  font-size: clamp(0.5rem, 1.5vw, .9rem);
}
.user-panel{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;

  .icons{
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    gap: 30px;
    cursor: pointer;

    .home{
      width: 20px !important;
      height: 17px !important;
    }

    img{
      width: 15px;
      height: 18px;
      
    }
  }

  .name{
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    position: relative;

    span{
      margin-left: 18px;
    }

    ul{
      display: flex;
      flex-direction: column;
      gap: 30px;
      list-style: none;
      position: absolute;
      top: 10px;
      left: 10px;
      background: #0B1426;
      border-radius: 8px;
      padding: 12px;

      li{
        display: flex;
        flex-direction: row;
        gap: 5px;
        font-size:clamp(12px , 2vw ,16px);

        .item{
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;
          color: rgba(215, 200, 200, 1);

          span{
            display: ruby;
          }
        }
      }
    }
  }

}
</style>